<script lang="ts">
    export let clasz: string = "";
    export let name: string = "";
    export let required: boolean = false;
    export let placeholder: string | undefined = "";
    export let maxlength: number | null = null;
    export let minlength: number | null = null;
    export let spellcheck: boolean;
    export let autocorrect: string;
    export let autocomplete: string;
    export let autocapitalize: string;
    export let autofocus: boolean = false;
    export let dir: string;
    export let value = "";
    export let oninput: (event: Event) => {} = null;

    let textareaElement: HTMLTextAreaElement;
    let dummyElement: HTMLDivElement;

    function syncDummyWithTextarea() {
        if (dummyElement && textareaElement) {
            dummyElement.dataset.replicatedValue = textareaElement.value;
        }
    }
    function autogrowOnInput(event: Event) {
        syncDummyWithTextarea();
        if (oninput) {
            oninput(event);
        }
    }
    let initialized = false;
    $: {
        if (dummyElement && textareaElement && textareaElement.value !== dummyElement.dataset.replicatedValue) {
            syncDummyWithTextarea();
            initialized = true;
        }
    }
</script>

<div class="grow-wrap">
    <textarea
        bind:this={textareaElement}
        class={clasz}
        {name}
        id="text"
        rows="1"
        {required}
        {maxlength}
        {minlength}
        {spellcheck}
        {autocapitalize}
        {autocorrect}
        {autocomplete}
        {autofocus}
        {placeholder}
        {dir}
        on:input={autogrowOnInput}
        bind:value
    />
    <div class="dummy {clasz}" bind:this={dummyElement} />
</div>

<style>
    .grow-wrap {
        /* easy way to plop the elements on top of each other and have them both sized based on the tallest one's height */
        display: grid;
    }
    .grow-wrap > .dummy {
        visibility: hidden;
    }
    .grow-wrap > .dummy::after {
        /* Note the weird space! Needed to preventy jumpy behavior */
        content: attr(data-replicated-value) " ";

        /* This is how textarea text behaves */
        white-space: pre-wrap;

        /* Hidden from view, clicks, and screen readers */
        visibility: hidden;
    }
    .grow-wrap > textarea {
        /* You could leave this, but after a user resizes, then it ruins the auto sizing */
        resize: none;

        /* Firefox shows scrollbar on growth, you can hide like this. */
        overflow: hidden;
    }
    .grow-wrap > textarea,
    .grow-wrap > .dummy {
        /* Place on top of each other */
        word-break: break-word;
        grid-area: 1 / 1 / 2 / 2;
    }
</style>
